// La duración de un video que se EDITA o COPIA a partir de otro —
// ADR-2026-09-25-editar-un-video-conserva-su-duracion.
//
// Editar un video es devolver EL MISMO video con un cambio: tiene que durar lo mismo. Antes
// la card caía al default de 5 s cuando el agente no mandaba `duration`, y el backend
// recortaba el video de referencia a esos 5 s (un video de 12 s volvió de 5). Ahora, sin
// una duración pedida, la salida dura lo que queda del video desde `desde`.

/**
 * El proveedor rechaza un video de referencia que llegue al tope de salida de su calidad:
 * en básica (hasta 15 s) 15 s de entrada se lee como más de 15 y lo rechaza, 14 entra; en
 * profesional (hasta 30 s) el tope de entrada es 29 (medido 2026-09-24; el de profesional,
 * ADR-2026-09-25-la-calidad-elegida-manda-con-video-de-referencia). Espejo de
 * `topeDeVideoDeReferencia` del backend.
 */
export const topeDeVideoDeReferencia = (topeCalidad: number): number => Math.max(1, topeCalidad - 1);
/** El tope de entrada de la calidad básica (15 − 1). Queda por los usos viejos. */
export const TOPE_VIDEO_REFERENCIA_S = 14;
/** Seedance no genera menos de 4 s. */
export const MINIMO_VIDEO_S = 4;

/**
 * La duración a pedir. `null` = todavía no se sabe cuánto dura el video (hay que medirlo
 * antes de generar). Puro.
 */
export function duracionConVideoDeReferencia(p: {
  /** Lo que mandó el agente (o eligió el usuario en la card), si mandó algo. */
  pedida?: number | null;
  /** Largo del video de referencia en segundos; 0 o null = desconocido. */
  duracionVideo?: number | null;
  desde?: number | null;
  /** Tope de SALIDA de la calidad elegida (15 en básica, 30 en profesional). */
  topeCalidad: number;
}): number | null {
  const tope = topeDeVideoDeReferencia(p.topeCalidad);
  const desde = Math.max(0, p.desde ?? 0);
  const restante =
    p.duracionVideo && p.duracionVideo > 0 ? Math.floor(p.duracionVideo - desde) : null;
  const techo = restante !== null ? Math.min(tope, Math.max(MINIMO_VIDEO_S, restante)) : tope;
  if (typeof p.pedida === 'number' && Number.isFinite(p.pedida) && p.pedida > 0) {
    return Math.min(techo, Math.max(MINIMO_VIDEO_S, Math.round(p.pedida)));
  }
  return restante !== null ? techo : null;
}
